// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { IsNotEmpty } from 'class-validator';

/* eslint-enable @typescript-eslint/no-unused-vars */ //JTH
export interface IContactInfo {
	fullName: string;

	email: string;

	phone: string | undefined;

	message: string | undefined;

	$type?: string | undefined;
}
export class ContactInfo {
	constructor(data?: IContactInfo) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	@IsNotEmpty()
	fullName: string = "";

	@IsNotEmpty()
	email: string = "";

	phone: string | undefined;

	message: string | undefined;

	static $type: string = "CoreApi.Models.View.ContactInfo, ";
	$type?: string | undefined = ContactInfo.$type;
}

